import { getApiUrl, API_URL } from '@/utils/api';
import { UntypedObject } from '@/types';
import ApiBase from './ApiBase';

export default class ContactService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/contact');

  sendMail(contactForm: UntypedObject, host: string) {
    return this.api.postJSON(`${ContactService.baseUrl}?host=${host}`, contactForm);
  }
}
